import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { MapPin, Navigation } from "lucide-react";

const LBL = { live: ["LIVE", "text-sky-300"], stale: ["Posizione non aggiornata", "text-amber-300"], offline: ["Telefono offline", "text-slate-400"],
  waiting: ["In attesa del GPS", "text-slate-400"], denied: ["Permesso negato", "text-rose-300"], unavailable: ["GPS non disponibile", "text-orange-300"] };
const ago = (iso) => { if (!iso) return ""; const s = Math.round((Date.now() - new Date(iso)) / 1000); return s < 60 ? `${s}s fa` : s < 3600 ? `${Math.floor(s / 60)} min fa` : `${Math.floor(s / 3600)} h fa`; };

export function BookingLiveGps({ bookingId, hasDriver }) {
  const nav = useNavigate();
  const [g, setG] = useState(null);
  useEffect(() => {
    if (!hasDriver) return undefined;
    const load = () => api.get(`/gps/booking/${bookingId}`).then(r => setG(r.data)).catch(() => setG(null));
    load();
    const t = setInterval(load, 20000);
    return () => clearInterval(t);
  }, [bookingId, hasDriver]);
  if (!hasDriver || !g) return null;
  const [label, cls] = g.available ? (LBL[g.status] || [g.status, "text-slate-300"]) : [g.reason === "not_active" ? "Posizione mostrata solo per servizi assegnati o in corso" : "Autista non in turno GPS", "text-slate-500"];
  return (
    <div className="rounded-xl border border-sky-500/25 bg-[#06101E] p-3 flex items-center gap-3" data-testid="booking-live-gps">
      <MapPin size={18} className="text-sky-400 flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="text-[10px] uppercase tracking-widest text-slate-500">Posizione LIVE autista</div>
        <div className={`text-sm font-bold ${cls}`} data-testid="booking-live-gps-status">{label}{g.position ? ` · agg. ${ago(g.position.received_at)}` : ""}</div>
      </div>
      {g.available && g.position && (
        <div className="flex gap-1.5">
          <a href={`https://www.google.com/maps/search/?api=1&query=${g.position.lat},${g.position.lng}`} target="_blank" rel="noreferrer"
            className="h-8 px-2.5 rounded-lg border border-sky-500/40 text-sky-300 text-xs inline-flex items-center gap-1" data-testid="booking-live-gps-maps"><Navigation size={12} />Maps</a>
          <button type="button" onClick={() => nav("/gps-live")} className="h-8 px-2.5 rounded-lg bg-sky-500 text-slate-950 text-xs font-bold" data-testid="booking-live-gps-open">GPS LIVE</button>
        </div>
      )}
    </div>
  );
}
